import styled from "@emotion/styled";
import { OutlinedInputProps } from "@mui/material";
import TextField, { TextFieldProps } from "@mui/material/TextField";
import React from "react";

const CustomTextField = styled(TextField)({
  textarea: {
    // it fixes this bug: https://github.com/mui/material-ui/issues/43718#issuecomment-2344882794
    "-moz-appearance": "textfield",
    "-webkit-appearance": "none",
    appearance: "textfield",
  },

  "&.MuiTextField-root": {
    height: "100%",
  },

  "& .MuiFilledInput-root": {
    overflow: "hidden",
    borderRadius: 4,
    backgroundColor: "#fff",
    border: "1px solid #fff",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 400,
    alignItems: "flex-start",
    boxSizing:
      "border-box" /* Ensure padding and borders are included in the width and height */,
    width: "100%",
    height: "100%",

    "& textarea": {
      boxSizing:
        "border-box" /* Ensure padding and borders are included in the width and height */,
      width: "100%",
      height: "100%",
      lineHeight: "22px",
    },

    "&:hover": {
      backgroundColor: "#F9F9F9",
    },
    "&.Mui-focused": {
      backgroundColor: "#F9F9F9",
      border: "1px solid #DDD",
    },
    // handle loading
    "&.Mui-disabled": {
      backgroundColor: "none",
    },
  },

  "& .MuiInputBase-root": {
    padding: 8,
  },
});

const TranslationInput = (props: TextFieldProps) => {
  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === " ") {
      event.stopPropagation();
    }
    if (event.key === "a" && (event.ctrlKey || event.metaKey)) {
      (event.target as HTMLTextAreaElement).select();
    }
  };

  return (
    <CustomTextField
      fullWidth
      multiline
      variant="filled"
      onKeyDown={handleKeyDown}
      InputProps={{ disableUnderline: true } as Partial<OutlinedInputProps>}
      {...props}
    />
  );
};

export default TranslationInput;
